import React, { useEffect, useCallback, useMemo, useState, useRef } from 'react';

import Chart from 'react-apexcharts';

import { useMonitoreo } from './MonitoreoContext';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const agregarCeroSiEsNecesario = (valor) => (valor < 10 ? `0${valor}` : `${valor}`);

export default function GraphStatus() {
    const [isShortScreen, setIsShortScreen] = useState(window.innerHeight <= 820);

    useEffect(() => {
        const handleResize = () => setIsShortScreen(window.innerHeight <= 820);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const {
        statusLinea,
        eficiYUti,
        dataP,
        setDataP,
        minX,
        setMinX,
        maxX,
        setMaxX,
        // dataEfi,
        setDataEfi,
        // dataUti,
        setDataUti,
        // xEfiUti,
        setXEfiUti,
        isLoadingStatusLinea,
    } = useMonitoreo();

    // Refs para preservar el zoom del usuario durante el polling
    const isUserZoomedRef = useRef(false);
    const zoomRangeRef = useRef({ min: undefined, max: undefined });

    // Altura dinámica según número de filas (líneas o celdas) devueltas
    const chartHeight = useMemo(() => {
        const minH = isShortScreen ? 130 : 160;
        const maxH = isShortScreen ? 380 : 500;
        const perRow = isShortScreen ? 44 : 56;
        const rows = statusLinea.length;
        return rows > 0 ? Math.min(maxH, Math.max(minH, rows * perRow)) : minH;
    }, [isShortScreen, statusLinea]);

    // const seriesLinea = [
    //     {
    //         name: 'Eficiencia',
    //         data: dataEfi,
    //     },
    //     {
    //         name: 'Utilización',
    //         data: dataUti,
    //     },
    // ];

    // const options1 = {
    //     chart: {
    //         height: 350,
    //         type: 'line',
    //         offsetX: 80,
    //         zoom: {
    //             enabled: false,
    //         },
    //         toolbar: {
    //             show: false,
    //         },
    //         animations: {
    //             enabled: true,
    //             easing: 'easeinout',
    //             speed: 700,
    //             animateGradually: {
    //                 enabled: true,
    //                 delay: 120,
    //             },
    //             dynamicAnimation: {
    //                 enabled: true,
    //                 speed: 350,
    //             },
    //         },
    //     },
    //     noData: {
    //         text: 'Cargando información',
    //         align: 'center',
    //         verticalAlign: 'center',
    //         offsetX: 0,
    //         offsetY: 0,
    //         style: {
    //             fontSize: '25px',
    //             fontFamily: 'WorkSans',
    //             fontWeight: 600,
    //             color: '#000',
    //         },
    //     },
    //     dataLabels: {
    //         enabled: false,
    //     },
    //     stroke: {
    //         width: [5, 5],
    //         curve: 'straight',
    //         dashArray: [0, 0],
    //     },
    //     // title: {
    //     //     text: 'Eificencia vs Utilizacion (min)',
    //     //     align: 'center',
    //     // },
    //     legend: {
    //         fontSize: '15px',
    //         tooltipHoverFormatter: function (val, opts) {
    //             return (
    //                 `${val
    //                 }: ${opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
    //                 } Min`
    //             );
    //         },
    //     },
    //     markers: {
    //         size: [5, 5],
    //         hover: {
    //             sizeOffset: 6,
    //         },
    //     },
    //     xaxis: {
    //         categories: xEfiUti,
    //     },
    //     tooltip: {
    //         enabled: true,
    //         style: {
    //             fontSize: '12px',
    //         },
    //         custom: function ({ series, seriesIndex, dataPointIndex, w }) {
    //             return (
    //                 `${'<div class="box">' +
    //                 '<div class="box-header">' +
    //                 '<h1>' +
    //                 ' Valores' +
    //                 '</h1>' +
    //                 '</div>' +
    //                 '<span>' +
    //                 'Eficiencia: '}${series[0][dataPointIndex]
    //                 } %` +
    //                 `</span>` +
    //                 `<span>` +
    //                 `Utilización: ${series[1][dataPointIndex]
    //                 } %` +
    //                 `</span>` +
    //                 `</div>`
    //             );
    //         },
    //     },
    //     grid: {
    //         borderColor: '#f1f1f1',
    //     },
    // };

    const options = useMemo(() => ({
        chart: {
            height: chartHeight,
            type: 'rangeBar',
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
            id: 'rangeBar',
            toolbar: { show: true, offsetX: 0, offsetY: chartHeight - 14 },
            parentHeightOffset: 0,
            offsetY: -10,
            events: {
                zoomed: function (_ctx, { xaxis }) {
                    isUserZoomedRef.current = true;
                    zoomRangeRef.current = { min: xaxis.min, max: xaxis.max };
                },
                scrolled: function (_ctx, { xaxis }) {
                    isUserZoomedRef.current = true;
                    zoomRangeRef.current = { min: xaxis.min, max: xaxis.max };
                },
                beforeResetZoom: function () {
                    isUserZoomedRef.current = false;
                    zoomRangeRef.current = { min: undefined, max: undefined };
                    return { xaxis: { min: minX, max: maxX } };
                },
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                    enabled: true,
                    delay: 150,
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 500,
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '75%',
                rangeBarGroupRows: true,
            },
        },
        noData: {
            text: isLoadingStatusLinea ? 'Cargando información' : 'No existen datos para esta selección',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
                fontSize: '18px',
                fontFamily: 'WorkSans',
                fontWeight: 600,
                color: '#5f606f',
            },
        },
        fill: {
            type: 'solid',
        },
        xaxis: {
            type: 'datetime',
            min: isUserZoomedRef.current ? zoomRangeRef.current.min : minX,
            max: isUserZoomedRef.current ? zoomRangeRef.current.max : maxX,
            labels: {
                show: true,
                datetimeUTC: false,
                style: {
                    fontFamily: 'WorkSans',
                    fontSize: '12px',
                    colors: '#5f606f',
                },
            },
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: '#5f606f',
                    fontSize: '13px',
                    fontFamily: 'WorkSans',
                    fontWeight: 600,
                },
            },
        },
        grid: {
            show: true,
            borderColor: '#90A4AE',
            strokeDashArray: 0,
            position: 'back',
            xaxis: {
                lines: {
                    show: false,
                },
            },
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        tooltip: {
            followCursor: true,
            shared: false,
            intersect: false,
            x: {
                show: true,
                format: 'dd MMM HH:mm',
                formatter: undefined,
            },
            fixed: {
                enabled: false,
            },
            custom: function ({ seriesIndex, dataPointIndex, w }) {
                const point = w.config.series[seriesIndex].data[dataPointIndex];
                if (!point || !Array.isArray(point.y) || point.y.length < 2) {
                    return '';
                }
                const fechaIni = new Date(point.y[0]);
                const fechaFin = new Date(point.y[1]);
                const duracion = point.z?.[1] ?? '';
                const fechaIniStr = fechaIni
                    .toLocaleString()
                    .slice(0, fechaIni.toLocaleString().length);
                const fechaFinStr = fechaFin.toLocaleString().slice(0, fechaFin.toLocaleString().length);

                return (
                    `<div class="arrow_box">` +
                    `<h3>${w.config.series[seriesIndex].name}</h3>` +
                    `<span>` +
                    `Fecha inicial: ${fechaIniStr}<br>` +
                    `Fecha Final: ${fechaFinStr}<br>` +
                    `Duración: ${duracion}` +
                    `</span>` +
                    `</div>`
                );
            },
        },
        // responsive: [
        //     {
        //         breakpoint: 1000,
        //         options: {
        //             chart: {
        //                 height: 350,
        //                 width: '70%',
        //             },
        //         },
        //     },
        // ],

        colors: [
            function ({ value, seriesIndex, w }) {
                // if (statusLinea.length > 0) {
                if (w.globals.seriesZ[seriesIndex].length > 0) {
                    if (w.globals.seriesZ[seriesIndex][0][0] === 0) {
                        return '#8A8A8A';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] === 1) {
                        return '#2ccb9e';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] === 2) {
                        return '#ffc800';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] === 3) {
                        return '#FE93C2';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] === 4) {
                        return '#94A3B8';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] === 5) {
                        return '#d3acac';
                    } else if (w.globals.seriesZ[seriesIndex][0][0] < 0) {
                        // Estatus negativos = paro especial autorizado
                        return '#ffe49e';
                    } else {
                        return '#fe424d';
                    }
                } else {
                    return '#fe424d';
                }
            },
        ],
        legend: {
            show: false,
        },
    }), [minX, maxX, chartHeight, isLoadingStatusLinea]);

    /**
     * Parsea una fecha devuelta por el API como UTC y devuelve el timestamp (epoch ms).
     * Si la cadena no tiene zona horaria (Z o ±HH:MM), se asume UTC para que al mostrarla
     * con toLocaleString() o en el gráfico se vea en hora local.
     */
    const parseApiDateAsUtc = useCallback((value) => {
        if (value == null) return NaN;
        const str = typeof value === 'string' ? value.trim() : String(value);
        if (!str) return NaN;
        const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(str);
        const toParse = hasTimezone ? str : `${str}Z`;
        const ts = Date.parse(toParse);
        return Number.isFinite(ts) ? ts : NaN;
    }, []);

    const msToHMS = useCallback((ms) => {
        let seconds = ms / 1000;
        const hours = parseInt(seconds / 3600);
        seconds = seconds % 3600;
        const minutes = parseInt(seconds / 60);
        seconds = seconds % 60;

        return `${agregarCeroSiEsNecesario(hours)}:${agregarCeroSiEsNecesario(
            minutes
        )}:${agregarCeroSiEsNecesario(Math.floor(seconds))}`;
    }, []);

    useEffect(() => {
        const data1 = [];
        let min = null;
        let max = null;

        statusLinea.forEach((estatusL) => {
            estatusL.datos.forEach((dato) => {
                const rawIni = parseApiDateAsUtc(dato.fechaHoraIni);
                const rawFin = parseApiDateAsUtc(dato.fechaHoraFin);
                if (!Number.isFinite(rawIni) || !Number.isFinite(rawFin)) {
                    return;
                }
                const start = Math.min(rawIni, rawFin);
                const end = Math.max(rawIni, rawFin);
                const diffMs = end - start;
                const diff = msToHMS(diffMs);

                if (min === null || start < min) min = start;
                if (max === null || end > max) max = end;

                data1.push({
                    name: dato.nombreEstatus,
                    data: [
                        {
                            x: estatusL.nombre,
                            y: [start, end],
                            z: [dato.estatus, diff, dato.folio],
                        },
                    ],
                });
            });
        });

        setDataP(data1);
        setMinX(min);
        setMaxX(max);
    }, [statusLinea, setDataP, setMinX, setMaxX, msToHMS, parseApiDateAsUtc]);

    useEffect(() => {
        let xValues = [];
        let dataE = [];
        let dataU = [];

        eficiYUti.forEach((eficiYU) => {
            xValues.push(eficiYU.periodo);
            dataE.push(eficiYU.oee);
            dataU.push(eficiYU.teep);
        });

        setXEfiUti(xValues);
        setDataUti(dataU);
        setDataEfi(dataE);
    }, [eficiYUti, setDataEfi, setDataUti, setXEfiUti]);

    return (
        <div className="monitoreoView-body-tittle-second">
            <div className="monitoreoView-body-tittle-second-lists">
                <div className="monitoreoView-body-tittle-second-lists-list0">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list0" />
                    <h4>Fuera</h4>
                </div>
                <div className="monitoreoView-body-tittle-second-lists-list1">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list1" />
                    <h4>Operando</h4>
                </div>
                <div className="monitoreoView-body-tittle-second-lists-list2">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list2" />
                    <h4>Setup</h4>
                </div>
                <div className="monitoreoView-body-tittle-second-lists-list5">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list5" />
                    <h4>Paro Planeado</h4>
                </div>
                <div className="monitoreoView-body-tittle-second-lists-list6">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list6" />
                    <h4>Paro no Planeado</h4>
                </div>
                <div className="monitoreoView-body-tittle-second-lists-list7">
                    <FiberManualRecordIcon className="monitoreoView-body-tittle-second-list7" />
                    <h4>Paro Autorizado</h4>
                </div>
            </div>
            <div className="graphStatus-chart-wrapper">
                <Chart
                    options={options}
                    series={dataP}
                    type="rangeBar"
                    id="rangeBar"
                    height={chartHeight}
                    width={'100%'}
                />
            </div>
            {/* Linea de tiempo OEE y Utilización*/}
            {/* <div style={{ width: '90%', display: 'block' }}>
                <Chart
                    options={options1}
                    series={seriesLinea}
                    type="line"
                    width={'98%'}
                    height={300}
                    id="chart"
                />
            </div> */}
        </div>
    );
}
